/**
 * Constantes PARTAGÉES des formulaires (validation + classes de champs).
 *
 * Extraction DRY à comportement strictement identique : ces valeurs étaient
 * copiées-collées à l'identique dans plusieurs formulaires. On les centralise
 * ICI sans rien « améliorer » — chaque littéral est repris octet pour octet
 * depuis les sites d'appel d'origine, pour garantir zéro changement de
 * comportement et zéro changement visuel.
 *
 * Module neutre (aucun import client/serveur) : importable depuis n'importe quel
 * composant — règle RSC respectée.
 */

/**
 * Motifs de validation téléphone, sous forme de `RegExp`.
 *
 * - `intl` : international PERMISSIF — « + » optionnel puis 7+ chiffres /
 *   séparateurs. Beaucoup de clients sont étrangers (+44, +1…) ; le motif FR
 *   strict rejetterait précisément ces leads internationaux. Utilisé par les
 *   formulaires lead (react-hook-form `pattern`) et par les dictionnaires
 *   véhicules (locale EN/AR).
 * - `fr` : France strict (06/+33…). Utilisé en locale FR des dictionnaires
 *   véhicules.
 *
 * NOTE : ce sont des `RegExp`. Les formulaires qui ont besoin d'une *chaîne*
 * pour l'attribut HTML `pattern=""` (ex. ExcursionPlanningForm) conservent leurs
 * propres littéraux — ils ne sont pas octet-pour-octet identiques à `.source`
 * (échappement du tiret différent pour `fr`), donc on n'y touche pas.
 */
export const PHONE_PATTERNS = {
  intl: /^\+?[0-9][0-9\s.\-()]{6,}$/,
  fr: /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
} as const;

/**
 * Classes Tailwind communes des champs de formulaire (reprises à l'identique).
 *
 * - `input` : input/select « compact » des formulaires lead + contact.
 * - `label` : libellé `<span>`/`<label>` au-dessus du champ.
 *
 * Les formulaires dont la classe diffère réellement (ex. ExcursionPlanningForm
 * en `min-h-12 rounded-xl px-4 text-[15px]`, ou les `<textarea>` en `resize-y`)
 * ne sont PAS concernés — seules les chaînes strictement identiques sont
 * centralisées ici.
 */
export const FORM_FIELD_CLASS = {
  input:
    "min-h-11 w-full rounded-lg border border-black/15 bg-white px-3 py-2.5 text-sm text-black outline-none ring-primary/40 transition focus:ring-2",
  label: "mb-1 block text-xs text-black/70",
} as const;
